import { MyAccountToggleSaveButtonStatsStore } from 'common/module/my-account/toggle-save-button/stats/store';
import { MyAccountToggleSaveButtonInteractionService } from 'common/service/my-account-toggle-save-button-interaction/service';
import { StatsService } from 'common/service/stats/service';

const service = new MyAccountToggleSaveButtonStatsStore(MyAccountToggleSaveButtonInteractionService(), StatsService());

export const MyAccountToggleSaveButtonStatsService = () => service;
